import {initialViewElementsState, IViewElementsState} from "../../state/system/system.state";
import {ESystemActions, SystemActions} from '../../actions/system/system.actions';


export const viewElementsReducers = (
  state: IViewElementsState = initialViewElementsState,
  action: SystemActions
): IViewElementsState => {
  switch (action.type) {
    case ESystemActions.SetViewMode: {
      return {
        ...state,
        viewMode: action.payload
      };
    }
    case ESystemActions.SetDisplaySize: {
      return {
        ...state,
        displaySize: {
          width: action.payload.width,
          height: action.payload.height
        }
      };
    }
    case ESystemActions.SetViewElementHeaderMode: {
      return {
        ...state,
        headerMode: action.payload
      };
    }

    case ESystemActions.SetViewElementSidebarMode: {
      return {
        ...state,
        sidebarMode: action.payload
      };
    }

    default:
      return state;
  }
};
